import { Box, Typography } from "@mui/material";
import { blue } from "@mui/material/colors";

const ConcreteCubeAccordingData = ({ start, quantity }) => {
  const numbers = Array.from({ length: quantity }, (_, index) => start + index);

  // 2. Map the numbers to an array of React elements
  const numberItems = numbers.map((number, index) => (
    <Box
      key={index} // Important for React's rendering performance[citation:1]
      sx={{
        p: 1, // padding
        m: 0.25, // margin
        bgcolor: "#787878",
        color: "white",
        borderRadius: 1,
        textAlign: "center",
      }}
    >
      <Typography>{number}</Typography>
    </Box>
  ));

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
      }}
    >
      {numberItems}
    </Box>
  );
};

export default ConcreteCubeAccordingData;
